import { Component, Input, OnInit } from '@angular/core';
import { Macros } from 'src/app/interfaces/macros';

@Component({
  selector: 'app-macros-list',
  templateUrl: './macros-list.component.html',
  styleUrls: ['./macros-list.component.scss'],
})
export class MacrosListComponent implements OnInit {
  @Input() macros?: Macros;
  @Input() tracked?: boolean;

  constructor() {}

  ngOnInit(): void {}
}
